import { Metamodel } from 'app/model/base/model';
import { Owned } from 'shell-models-lib';
import { Transformation } from '../transformation';
import { type IKeyColumnsEntity } from '../dataflow-sink';
import { type DataFlowExpression } from '../dataflowexpression';

export enum DatasetTypeOptions {
    Dataset = 'dataset',
    Inline = 'inline',
    Cache = 'cache',
    WorkspaceDatabases = 'workspacedatabases'
}

export enum DatasetFormatType {
    CDM = 'cdm',
    Delimited = 'delimited',
    Parquet = 'parquet',
    Excel = 'excel',
    Hive = 'hive',
    SqlDBDeprecated = 'sqldb',
    SqlDB = 'sqlserver',
    SqlMI = 'sqlmi',
    SynapseAnalytics = 'synapseanalytics',
    Xml = 'xml',
    AdobeCampaign = 'adobecampaign',
    AdobeIOEvents = 'adobeevent',
    AdobePrivacy = 'adobeprivacy',
    Delta = 'delta',
    Orc = 'orc',
    Avro = 'avro',
    Snowflake = 'snowflake',
    SnowflakeV2 = 'snowflakeV2',
    Cache = 'cache',
    PostgreSql = 'postgres',
    Json = 'json',
    Mysql = 'mysql',
    OnPremiseSqlServer = 'onpremisesqlserver',
    Rest = 'rest',
    RestCall = 'restCall',
    ADX = 'azuredataexplorer',
    Dynamics = 'dynamics',
    DynamicsCRM = 'dynamicsCRM',
    Dataverse = 'dataverse',
    TeamDesk = 'teamdesk',
    CosmosDB = 'cosmosDB',
    CosmosDBMongo = 'cosmosDBMongo',
    Quickbase = 'quickbase',
    SapODP = 'SapOdp',
    Smartsheet = 'smartsheet',
    Zendesk = 'zendesk',
    Microsoft365 = 'microsoft365',
    Oracle = 'oracle',
    Workday = 'workday',
    EventHubs = 'eventHubs',
    SapOData = 'SapOData',
    Kafka = 'kafka',
    Cassandra = 'cassandra',
    Iceberg = 'iceberg',
    Salesforce = 'Salesforce',
    Warehouse = 'fabricdw',
    LakehouseFiles = 'lakehouseFiles',
    LakehouseTables = 'lakehouseTables'
}

@Metamodel.model({
    abstract: true
})
export abstract class DataFlowDatasetSettings extends Owned implements IKeyColumnsEntity {
    protected get transform(): Transformation {
        return this.owner as Transformation;
    }

    public get includeSchemaLinkedServiceInResource(): boolean {
        return true;
    }

    @Metamodel.attribute({
        display: stringResources.DataFlowSinkAllowInsert
    })
    public allowInsert: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowSinkAllowDelete
    })
    public allowDelete: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowSinkAllowUpsert
    })
    public allowUpsert: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowSinkAllowUpdate
    })
    public allowUpdate: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowDatasetKeyColumns
    })
    public keyColumns: DataFlowExpression[];

    @Metamodel.attribute({
        display: stringResources.DataFlowDatasetAdditionalConfigs
    })
    public additionalConfigs: Array<Record<'key' | 'value', DataFlowExpression>>;

    public isListOfKeyColumns: boolean = true;

    public abstract getDatasetType(): string;

    public abstract getFormat(): DatasetFormatType;

    public abstract getSubFormat(): string;

    public abstract initialize(subFormat: string): void;

    public abstract getIconClass(): string;

}
